import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase/firebase';

/**
 * Uploads an image file to Firebase Storage under users/{uid}/images/
 * Returns the public download URL.
 */
export async function uploadRecipeImage(file, uid) {
  if (!file || !uid) throw new Error('file and uid are required');
  const ext = file.name.split('.').pop();
  const filename = `${Date.now()}_${Math.random().toString(36).slice(2)}.${ext}`;
  const path = `users/${uid}/images/${filename}`;
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file);
  return getDownloadURL(storageRef);
}
